export default __webpack_public_path__ + "static/media/pin.df208adf.svg";